module.exports = __webpack_public_path__ + "static/media/certificado_assinatura1.b20817d5.png";